import * as yup from 'yup';

/**
 * Form data type for editing a site
 */
export interface EditSiteFormData {
  name: string;
  what3words?: string;
  notes?: string;
  latitude?: number | null;
  longitude?: number | null;
}

export const normalizeWhat3WordsAddress = (value: string): string =>
  value.replace(/^\/+/, '');

/**
 * Validation schema for editing a site
 * Following form-architecture.md Yup patterns
 */
export const editSiteSchema: yup.ObjectSchema<EditSiteFormData> = yup.object({
  name: yup
    .string()
    .required('Site name is required')
    .max(100, 'Site name cannot exceed 100 characters'),
  what3words: yup
    .string()
    .matches(/^[a-zA-Z]+\.[a-zA-Z]+\.[a-zA-Z]+$/, {
      message: 'Must be word.word.word format',
      excludeEmptyString: true,
    })
    .optional(),
  notes: yup
    .string()
    .max(4048, 'Notes cannot exceed 4048 characters')
    .optional(),
  latitude: yup.number().nullable().notRequired(),
  longitude: yup.number().nullable().notRequired(),
});
